import 'css-chunksrc/client/scenes/zone/projects/styles.scss';export default {
  "projects": "_projects_1e7n3_1",
  "projectList": "_projectList_1e7n3_5"
};